// extracted by mini-css-extract-plugin
module.exports = {"min-width-0":"InputGroup_min-width-0__ZQvkq","flex-shrink-0":"InputGroup_flex-shrink-0__gY2R_"};